"use client";

import React from "react";
import { HeartPulse, ShieldCheck, Smile, HeartHandshake } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Elite Health Testing",
  description: "Every sire and dam undergoes rigorous OFA clearances for heart, eyes, and patellas to ensure a lifetime of vitality for our puppies.",
  icon: HeartPulse
}, {
  title: "Royal Pedigree",
  description: "Our dogs come from champion lineages, selected for their exquisite conformation and strict adherence to AKC breed standards.",
  icon: HeartHandshake
}, {
  title: "Temperament First",
  description: "Raised in our home, our puppies are socialized from day one to be the gentle, affectionate companions the Cavalier is known for.",
  icon: Smile
}];
export default function WhyAWhiskersKitten() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardsRef,
    isVisible: isCardsVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="141329" id="the-cobrnik-standard" className="bg-secondary/10 py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground mb-4">
            The Cobrnik Standard
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            As AKC Breeders of Merit, we uphold the highest levels of health, temperament, and beauty in every Cavalier King Charles Spaniel.
          </p>
        </div>

        <div className="w-full">
          <div ref={cardsRef} className={`grid grid-cols-1 sm:grid-cols-3 gap-6 px-0 ml-0 transition-all duration-1000 ease-out delay-300 ${isCardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            return <div data-index={i} key={i} className="h-full">
                  <Card className="h-full bg-card border border-secondary/30 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 group rounded-xl">
                    <CardHeader className="pb-3">
                      <div className="size-12 rounded-xl bg-background flex items-center justify-center mb-4 shadow-xs group-hover:bg-primary/5 transition-colors border border-secondary/20">
                        <Icon className="size-6 text-primary" />
                      </div>
                      <CardTitle className="font-serif text-xl text-foreground font-semibold">
                        {benefit.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-muted-foreground leading-relaxed font-sans text-sm">
                        {benefit.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>;
          })}
          </div>

        </div>
      </div>
    </section>;
}